import configs from "@/config/config.js";

let request = {
  async mypost($axios, url, ...postData) {
    $axios.setHeader({
      authorization: localStorage.getItem("Bearer") || "none",
      "accept-language": localStorage.getItem("lang"),
      lang: localStorage.getItem("lang"),
      appId: configs.bipAppId()
    });
    var res = await $axios.post(url, {
      ...postData[0],
      token: localStorage.getItem("Bearer") || "none"
    });
    if (res.data.stateCode == -1) {
      var Tokenres = await $axios.post(
        `${tgaPlatformSDK.data.BaseHost}/api/v1/auth/token/refresh`,
        {
          refreshToken: localStorage.getItem("refreshToken") || "",
          fpId: tgaPlatformSDK.util.cookies.get("tga-fpid")
        }
      );
      if (Tokenres.data.code != 200) {
        const login = await tgaPlatformSDK.uc.login({
          fpId: localStorage.getItem("msisdn")
            ? localStorage.getItem("msisdn") + ""
            : "",
          // 原生端返回的APPID
          // nickname: localStorage.getItem("nickname"),
          appId: configs.bipAppId()
          // type: 13
        });
        if (login) {
          localStorage.setItem("Bearer", login.accessToken);
          localStorage.setItem("refreshToken", login.refreshToken);
          res = await $axios.post(url, {
            ...postData[0],
            token: localStorage.getItem("Bearer") || "none"
          });
        } else {
          window.history.go(0);
        }
      } else {
        localStorage.setItem("Bearer", Tokenres.data.data.accessToken);
        localStorage.setItem("refreshToken", Tokenres.data.data.refreshToken);
        $axios.setHeader({
          authorization: localStorage.getItem("Bearer") || "none",
          "accept-language": localStorage.getItem("lang"),
          lang: localStorage.getItem("lang"),
          appId: configs.bipAppId()
        });
        res = await $axios.post(url, {
          ...postData[0],
          token: localStorage.getItem("Bearer") || "none"
        });
      }
    }
    return res;
  },
  async myget($axios, url, ...postData) {
    $axios.setHeader({
      authorization: localStorage.getItem("Bearer") || "none",
      "accept-language": localStorage.getItem("lang"),
      lang: localStorage.getItem("lang"),
      appId: configs.bipAppId()
    });
    var res = await $axios.get(url, {
      params: {
        ...postData[0],
        lang: localStorage.getItem("lang"),
        token: localStorage.getItem("Bearer") || "none"
      }
    });
    console.log("resresresresres+++++", res);
    if (res.data.stateCode == -1 || res.data.Error == -1) {
      var refreshToken = localStorage.getItem("bip-refreshToken") || "";
      var Tokenres = await $axios.post(
        `${tgaPlatformSDK.data.BaseHost}/api/v1/auth/token/refresh`,
        {
          refreshToken: localStorage.getItem("refreshToken") || "",
          fpId: tgaPlatformSDK.util.cookies.get("tga-fpid")
        }
      );
      if (Tokenres.data.code != 200) {
        const login = await tgaPlatformSDK.uc.login({
          fpId: localStorage.getItem("msisdn")
            ? localStorage.getItem("msisdn") + ""
            : "",
          // 原生端返回的APPID
          // nickname: localStorage.getItem("nickname"),
          appId: configs.bipAppId()
          // type: 13
        });
        if (login) {
          localStorage.setItem("Bearer", login.accessToken);
          localStorage.setItem("refreshToken", login.refreshToken);
          res = await $axios.post(url, {
            ...postData[0],
            token: localStorage.getItem("Bearer") || "none"
          });
        } else {
          window.history.go(0);
        }
      } else {
        localStorage.setItem("Bearer", Tokenres.data.data.accessToken);
        localStorage.setItem("refreshToken", Tokenres.data.data.refreshToken);
        $axios.setHeader({
          authorization: Tokenres.data.resultInfo.accessToken,
          "accept-language": localStorage.getItem("lang"),
          lang: localStorage.getItem("lang"),
          appId: configs.bipAppId()
        });

        res = await $axios.get(url, {
          params: {
            ...postData[0],
            lang: localStorage.getItem("lang"),
            token: localStorage.getItem("Bearer") || "none"
          }
        });
      }
    }
    return res;
  }
};

export default request;



// WEBPACK FOOTER //
// ./src/vuex/modules/require.js